import React, { useEffect, useState } from "react";
import "./Categories.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllBrands,
  getAllColors,
  getAllSizes,
  getAllSubCategory,
} from "../../features/master/masterSlice";
import { getAllProducts } from "../../features/products/productsSlice";
import { getHomeBanner } from "../../features/home/homeSlice";
import Product_Info_Card from "../common-components/product_info_card/Product_Info_Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Nav } from "react-bootstrap";
import Category_Subcategory_Card from "../common-components/category_subcategory_card/Category_Subcategory_Card";
import { variant_type } from "../../utils/common";
import Pagination_Holder from "../common-components/pagination_holder/Pagination_Holder";
import Sort_offcanvas from "../shop/all_Product/sort_offcanvas/Sort_offcanvas";
import Filter_offcanvas from "../shop/all_Product/filter_offcanvas/Filter_offcanvas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faSort } from "@fortawesome/free-solid-svg-icons";

const STEP = 4;

function SubCategories() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();

  const [onPageChange, setOnPageChange] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [showFilter, setShowFilter] = useState(false);
  const [showSort, setShowSort] = useState(false);

  const handleShow = () => {
    setShowFilter(true);
    setShowSort(false);
  };

  const handleClose = () => {
    setShowFilter(false);
    setShowSort(false);
  };

  const handleShowSort = () => {
    setShowSort(true);
    setShowFilter(false);
  };

  const handleCloseSort = () => {
    setShowSort(false);
    setShowFilter(false);
  };

  const [sortOrder, setSortOrder] = useState("");
  const [appliedSortOrder, setAppliedSortOrder] = useState("");

  const [filters, setFilters] = useState({
    category: [],
    subCategory: [],
    brands: [],
    colors: [],
    sizes: [],
  });

  const [appliedFilters, setAppliedFilters] = useState({
    category: [],
    subCategory: [],
    brands: [],
    colors: [],
    sizes: [],
  });

  const updateFilter = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const subcategories = useSelector((state) => state.master.subcategories);
  const categories = useSelector((state) => state.master.categories);

  const brands = useSelector((state) => state.master.all_brands);
  const colors = useSelector((state) => state.master.all_colors);
  const sizes = useSelector((state) => state.master.all_sizes);
  const all_products = useSelector((state) => state.product.allProducts);

  const [selectedSubCategory, setSelectedSubCategory] = useState("");

  const params = new URLSearchParams(location.search);
  const search = params.get("search");

  // const category_image = location.state?.category_image;

  // const searchedSubCategoryId = location.state?.subcategory_id;

  const productPerPage = 10;

  const breadcrumbs = [
    {
      label: "Home",
      link: "/",
      isActive: false,
    },
    {
      label: "Categories",
      link: "",
      isActive: true,
    },
  ];

  useEffect(() => {
    dispatch(getAllCategories());
    dispatch(getAllBrands());
    dispatch(getAllColors());
    dispatch(getAllSizes());
  }, [dispatch]);

  const currentCategory = categories?.find(
    (category) => String(category?.id) === String(id),
  );

  const category_image = location.state?.category_image || currentCategory?.image;

  const searchedSubCategoryId = location.state?.subcategory_id || params.get("subcategory_id");

  // useEffect(() => {
  //   if (id) {
  //     dispatch(
  //       getAllSubCategory({
  //         category_id: id,
  //       }),
  //     );
  //   }
  // }, [dispatch, id]);

  useEffect(() => {
    if (!id) return;

    dispatch(
      getAllSubCategory({
        category_id: id,
      }),
    );
  }, [dispatch, id]);

  useEffect(() => {
    if (!searchedSubCategoryId || !subcategories?.length) return;

    const matchedSubCategory = subcategories.find(
      (item) => String(item?.id) === String(searchedSubCategoryId),
    );

    if (matchedSubCategory) {
      setSelectedSubCategory(matchedSubCategory.id);

      setFilters((prev) => ({
        ...prev,
        subCategory: [matchedSubCategory.id],
      }));

      setAppliedFilters((prev) => ({
        ...prev,
        subCategory: [matchedSubCategory.id],
      }));

      setOnPageChange(1);
    }
  }, [searchedSubCategoryId, subcategories]);

  useEffect(() => {
    dispatch(getHomeBanner());
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getAllProducts({
        // name: search,
        // category_id: id,

        name: search || "",
        category_id: search ? "" : id,
        subcategory_id:
          appliedFilters.subCategory.length > 0
            ? appliedFilters.subCategory.join(",")
            : selectedSubCategory || "",

        brand_id:
          appliedFilters.brands.length > 0
            ? appliedFilters.brands.join(",")
            : "",

        color_id:
          appliedFilters.colors.length > 0
            ? appliedFilters.colors.join(",")
            : "",

        size_id:
          appliedFilters.sizes.length > 0 ? appliedFilters.sizes.join(",") : "",

        sortBy: appliedSortOrder,
        page: onPageChange,
        per_page: productPerPage,
      }),
    );
  }, [
    id,
    search,
    selectedSubCategory,
    appliedFilters,
    appliedSortOrder,
    onPageChange,
  ]);

  useEffect(() => {
    if (all_products && all_products.data) {
      setTotalPages(all_products.total_pages);

      if (all_products.current_page) {
        setOnPageChange(all_products.current_page);
      }
    }
  }, [all_products]);

  const handlePageChange = (pageNumber) => {
    setOnPageChange(pageNumber);
  };

  const handleApplyFilters = () => {
    setAppliedFilters(filters);

    if (filters.subCategory.length > 0) {
      setSelectedSubCategory(filters.subCategory[0]);
    } else {
      setSelectedSubCategory("");
    }

    setOnPageChange(1);

    setShowFilter(false);
  };

  const handleClearFilters = () => {
    const emptyFilters = {
      category: [],
      subCategory: [],
      brands: [],
      colors: [],
      sizes: [],
    };

    setFilters(emptyFilters);
    setAppliedFilters(emptyFilters);

    setSelectedSubCategory("");

    setSortOrder("");
    setAppliedSortOrder("");

    setOnPageChange(1);

    setShowFilter(false);
    setShowSort(false);
  };

  const handleSubCategoryClick = (subcategoryId) => {
    setSelectedSubCategory(subcategoryId);

    setFilters((prev) => ({
      ...prev,
      subCategory: subcategoryId ? [subcategoryId] : [],
    }));

    setAppliedFilters((prev) => ({
      ...prev,
      subCategory: subcategoryId ? [subcategoryId] : [],
    }));

    setOnPageChange(1);
  };

  return (
    <section className="Categories_section_holder">
      <div className="container-fluid">
        <div className="Categories">
          <Breadcrumb_comp breadcrumbs={breadcrumbs} />

          <div className="heading_holder">
            <h4 className="heading_text">Essentials</h4>
          </div>

          <div className="cat_subcat_div">
            <div variant="pills" className="flex-row p-0 mb-3">
              <Swiper
                className="mySwiper"
                pagination={{
                  dynamicBullets: true,
                  clickable: true,
                }}
                modules={[Pagination, Navigation]}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  350: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },
                  486: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },
                  576: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                  },
                  768: {
                    slidesPerView: 5,
                    spaceBetween: 10,
                  },
                  992: {
                    slidesPerView: 6,
                    spaceBetween: 10,
                  },
                  1200: {
                    slidesPerView: 6,
                    spaceBetween: 10,
                  },
                }}
              >
                <SwiperSlide className="product-slide">
                  <Nav.Item>
                    <Nav.Link
                      eventKey=""
                      className={
                        selectedSubCategory === "" ? "activecategory" : ""
                      }
                      onClick={() => {
                        handleSubCategoryClick("");
                      }}
                    >
                      <Category_Subcategory_Card
                        className="product-image"
                        content="All Product"
                        image={process.env.REACT_APP_IMG_URL + category_image}
                        imgClassName="category-image"
                      />

                      <div className="triangle-right"></div>
                    </Nav.Link>
                  </Nav.Item>
                </SwiperSlide>

                {subcategories?.map((slide, index) => (
                  <SwiperSlide key={index} className="product-slide">
                    <Nav.Item>
                      <Nav.Link
                        eventKey={slide?.id}
                        className={
                          String(selectedSubCategory) === String(slide?.id)
                            ? "activecategory"
                            : ""
                        }
                        onClick={() => {
                          handleSubCategoryClick(slide?.id);
                        }}
                      >
                        <Category_Subcategory_Card
                          className="product-image"
                          content={slide?.name}
                          image={process.env.REACT_APP_IMG_URL + slide?.image}
                          imgClassName="category-image"
                        />

                        <div className="triangle-right"></div>
                      </Nav.Link>
                    </Nav.Item>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

          <div className="mobile_filter_btn">
            <button onClick={handleShow} className="filter_btn">
              <FontAwesomeIcon
                icon={faFilter}
                style={{
                  color: "rgb(136 74 41)",
                }}
              />

              <span>Filters</span>
            </button>

            <button onClick={handleShowSort} className="filter_btn ms-2">
              <FontAwesomeIcon
                icon={faSort}
                style={{
                  color: "rgb(136 74 41)",
                }}
              />

              <span>Sort</span>
            </button>
          </div>

          {all_products?.data?.length <= 0 ? (
            <p className="text-center text-danger mt-5">
              No products available for this selection.
            </p>
          ) : (
            <>
              <div className="heading_holder">
                <h4 className="heading_text">Products</h4>
              </div>

              <div className="row">
                {all_products?.data?.map((product, index) => {
                  let metal;
                  let size;
                  let triple;

                  if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Single)
                  ) {
                    metal = product?.Product_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Double)
                  ) {
                    metal = product?.Product_Variants?.[0];

                    size = metal?.Double_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Triple)
                  ) {
                    metal = product?.Product_Variants?.[0];

                    size = metal?.Double_Variants?.[0];

                    triple = size?.Triple_Variants?.[0];
                  }

                  const activeVariant = triple || size || metal;

                  return (
                    <div
                      className="col-lg-4 col-md-4 col-sm-6 col-6 px-md-2 px-1 custom_5_col"
                      key={product?.id || index}
                    >
                      <Product_Info_Card
                        product={product}
                        id={product?.id}
                        imgSrc={process.env.REACT_APP_IMG_URL + product?.image}
                        vdoSrc={process.env.REACT_APP_IMG_URL + product?.video}
                        productName={product?.name}
                        priceText={activeVariant?.price || 0}
                        mrp={activeVariant?.mrp || 0}
                        kgText={activeVariant?.name}
                        savingPrice={
                          parseFloat(activeVariant?.mrp || 0) -
                          parseFloat(activeVariant?.price || 0)
                        }
                        fromSubCategory={true}
                        categoryId={id}
                        subcategoryId={selectedSubCategory}
                      />
                    </div>
                  );
                })}
              </div>
            </>
          )}

          <div className="pagination_div">
            <Pagination_Holder
              onPageChange={onPageChange}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>

        <div className="buttons_div">
          <Filter_offcanvas
            show={showFilter}
            handleClose={handleClose}
            filters={filters}
            updateFilter={updateFilter}
            handleApplyFilters={handleApplyFilters}
            handleClearFilters={handleClearFilters}
            categories={currentCategory ? [currentCategory] : []}
            subCategories={subcategories}
            colours={colors}
            sizes={sizes}
            brands={brands}
          />

          <Sort_offcanvas
            show={showSort}
            handleClose={handleCloseSort}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            appliedSortOrder={appliedSortOrder}
            setAppliedSortOrder={(value) => {
              setAppliedSortOrder(value);
              setOnPageChange(1);
            }}
          />
        </div>
      </div>
    </section>
  );
}

export default SubCategories;
